// import external dependencies
import jquery from 'jquery';
window.$ = jquery;
global.$ = jquery;
window.jQuery = jquery;
global.jQuery = jquery;

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';

// import local dependencies
import './util/loading.js';
import Router from './util/router';
import common from './routes/common';
import home from './routes/home';

var MobileDetect = require('mobile-detect');

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

var md = new MobileDetect(window.navigator.userAgent);

if (md.mobile()) {
	jQuery('.navbar .dropdown > a').click(function(e){
    e.preventDefault();
  });

  jQuery('.dropdown').on("show.bs.dropdown", function(){
    jQuery(this).find('a').click(function(){
      location.href = this.href;
    });
	});
}

jQuery(function($) {
  if ($(window).width()>769) {
    $('.navbar .dropdown').hover(function() {
      $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();
    }, function() {
      $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();
    });

    $('.navbar .dropdown > a').click(function(){
      location.href = this.href;
    });
  }
});

// Chargement de la popup
window.onload = () => {
  $('#hotelModal').modal('show');
}



// WEBPACK FOOTER //
// ./scripts/main.js